/*
 * Server detail view Stats tab
 */

(function (__module__) {
    'use strict';

    function initializeScheduleChart(barColor=null, idPrefix=null) {

        if (idPrefix === null) {
            idPrefix = '';
        }
        const schedJson = JSON.parse(document.getElementById(idPrefix+'sched-json').textContent);

        const toTimeSlot = function(hour, minute) {
            return (hour * 4) + (minute / 15);  // Convert to 15-minute slots
        };

        const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

        // Build a Map keyed by day index so each x value has exactly one entry
        let seriesMap = new Map();
        for (let i = 0; i < 7; i++) {
            seriesMap.set(i, { x: i, low: null, high: null });
        }

        const updateDay = function(day, low, high) {
            const existing = seriesMap.get(day);
            if (existing.low === null) {
                seriesMap.set(day, { x: day, low: low, high: high });
            } else {
                seriesMap.set(day, { x: day, low: Math.min(existing.low, low), high: Math.max(existing.high, high) });
            }
        };

        schedJson.forEach(function(schedData) {
            const onSlot = toTimeSlot(schedData.on_hour, schedData.ontimeslot);
            const offSlot = toTimeSlot(schedData.off_hour, schedData.offtimeslot);

            if (schedData.off_day === schedData.on_day && onSlot < offSlot) {
                // Simple case: ON and OFF in the same day
                updateDay(schedData.on_day, onSlot, offSlot);
            } else {
                // Handling for schedules spanning multiple days
                let on_day = schedData.on_day;
                let off_day = on_day;

                updateDay(on_day, onSlot, 96);  // Last time slot of the day

                if (schedData.off_day < on_day || (schedData.off_day === on_day && onSlot > offSlot)) {
                    schedData.off_day += 7;  // Adjust for wrap-around
                }
                while (off_day < schedData.off_day) {
                    on_day++;
                    off_day++;

                    if (on_day === 7) {
                        on_day = 0;  // Reset to Monday
                    }

                    // If the next day is the off_day, set the new_off_slot to the offSlot
                    // Use the mod operator to account for wrap-around
                    const new_off_slot = (on_day === (schedData.off_day % 7)) ? offSlot : 96;
                    updateDay(on_day, 0, new_off_slot);
                }
            }
        });

        // Convert map to sorted array — one entry per day
        let highchartSeries = Array.from(seriesMap.values()).sort((a, b) => a.x - b.x);

        let seriesColor = barColor || '#3DC449';
        $('#' + idPrefix + 'powerScheduleChart').highcharts({
            chart: {
                type: 'columnrange',
                inverted: true
            },
            credits: {enabled: false},
            legend: {enabled: false},
            title: {text: ''},
            plotOptions: {
                columnrange: {
                    grouping: true,
                }
            },
            xAxis: {
                categories: daysOfWeek
            },
            yAxis: {
                title: {enabled: false},
                labels: {
                    formatter: function() {
                        let hour = Math.floor(this.value / 4);
                        let minute = (this.value % 4) * 15;
                        return hour + ':' + (minute === 0 ? '00' : minute);
                    }
                },
                tickInterval: 12, // Every hour (4 slots)
                min: 0,
                max: 96,  // 24 hours * 4 slots/hour
            },
            tooltip: {
                formatter: function() {
                    let startSlot = this.point.low;
                    let endSlot = this.point.high;

                    let startHour = Math.floor(startSlot / 4);
                    let startMinute = (startSlot % 4) * 15;

                    let endHour = Math.floor(endSlot / 4);
                    let endMinute = (endSlot % 4) * 15;

                    let startTime = `${startHour}:${startMinute === 0 ? '00' : startMinute}`;
                    let endTime = `${endHour}:${endMinute === 0 ? '00' : endMinute}`;

                    let day = this.series.chart.xAxis[0].categories[this.point.x];

                    return `<b>${day}, Power Schedule:</b> ${startTime} to ${endTime}`;
                }
            },
            series: [{
                name: 'Power Schedule',
                groupPadding: 0,
                data: highchartSeries,
                color: seriesColor,
                animation: false,
            }]
        });
    }

    c2[__module__] = {
        initializeScheduleChart: initializeScheduleChart
    };

})('power_schedule');
